import { create } from 'zustand';

type TNavigationBlockerState = {
  shouldBlock: boolean;
  allowedRoutes: string[];
  setShouldBlock: (shouldBlock: boolean) => void;
  setAllowedRoutes: (routes: string[]) => void;
  onExitWithoutSave: () => void;
  setOnExitWithoutSave: (onExit: () => void) => void;
};

export const useNavigationBlockerStore = create<TNavigationBlockerState>(set => ({
  shouldBlock: false,
  allowedRoutes: [],
  setShouldBlock: (shouldBlock: boolean) => set({ shouldBlock }),
  setAllowedRoutes: (routes: string[]) => set({ allowedRoutes: routes }),
  onExitWithoutSave: () => {},
  setOnExitWithoutSave: (onExit: () => void) => set({ onExitWithoutSave: onExit }),
}));
